export enum RoutesPath {
  SIGN_IN = 'sign-in',
  SIGN_UP = 'sign-up',
  UNSUBSCRIBE = 'unsubscribe',
  FORGOT_PASSWORD = 'forgot-password',
  RESET_PASSWORD = 'reset-password',
  CONTACT = 'contact',
  SERVICES = 'services',
  ARTICLES = 'articles',
  LANDINGS = 'landings',
  DASHBOARD = 'dashboard',
  NOT_FOUND = 'not-found',
  ABOUT = 'about',
  PREVIEW = 'preview',
  PAYMENT_INTENT = 'payment-intent',
  PAYMENT_VALIDATION = 'payment-validation',
  LOADING = 'loading',
  LOADING_PREVIEW = 'loading-preview',
  PRICING = 'pricing',
  TESTIMONIALS = 'testimonials',
  SERVICE = 'service',
  VIN = 'vin',
  COMPARE = 'compare',
  PARTNERS = 'partners',
  GLOSSARY = 'glossary',
  COMPANY = 'company',
  LEASING = 'leasing',
  INSURANCE = 'insurance',
  AFFILIATE = 'affiliate',
  SSO = 'sso',
  CAREERS = 'careers',
  GUIDE = 'guide',
  PRESS = 'press',
  CAR_NOT_FOUND = 'car-not-found',
}
